import React, { useState } from 'react'
import {
  Button,
  // IconButton,
  makeStyles,
  TableCell,
  TableRow,
  DialogActions,
  DialogContentText,
  Typography,
  Dialog,
  DialogContent
} from "@material-ui/core";
import { useDispatch, useSelector } from 'react-redux';
import { 
  ESTADO_SOLICITUD_INTEGRACION, 
} from '../../data/constants';
// import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
// import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { ModalHistorialCambios } from '../../../autorizaciones/gestionAuditoria/ModalHistorialCambios';
import { ModalAuditarSolicitudIntegracion } from './modalAuditar/ModalAuditarSolicitudIntegracion';
import InfoHistorialIcon from '../../../autorizaciones/UI/InfoHistorialIcon';
import IconEstado from '../../../autorizaciones/UI/IconEstado';
import { 
  postTomarSolicitudDiscapacidad, 
  putLiberarSolicitudDiscapacidad, 
  setSolicitudDiscapacidad 
} from '../../../../actions/discapacidad/discapacidadActions';

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const SolicitudIntegracionItem = ({item, setRedirect, expandirPracticas = false,
  tieneBandejaEnCarga, tieneBandejaPendiente, tieneBandejaPendienteAutorizacion}) => {
  const classes = useRowStyles();
  const dispatch = useDispatch();

  const { idUsuario } = useSelector((state) => state.auth);

  // const [open, setOpen] = useState(expandirPracticas);
  const [openModalAuditar, setOpenModalAuditar] = useState(false);
  const [openModalHistorialCambios, setOpenModalHistorialCambios] = useState(false);  
  const { solicitudesTomadasUsuario } = useSelector((state) => state.discapacidad);
  const [openAlert, setOpenAlert] = React.useState(false);

  // useEffect(() => {
  //     dispatch( getSolicitudesDiscapacidadTomadasPorUsuario() );
  // }, [dispatch]);

  const postIrASolicitud = (item) => {
    dispatch(setSolicitudDiscapacidad(item));
    setRedirect(true);
  }

  const disabled = (item?.idEstadoSolicitud ===
    ESTADO_SOLICITUD_INTEGRACION.AUTORIZADA ||
    item?.idEstadoSolicitud ===
    ESTADO_SOLICITUD_INTEGRACION.RECHAZADA)

    const handleLiberar = () => {      
      const itemTomado = solicitudesTomadasUsuario.find((item) => item.idUsuarioTomada === idUsuario && item.fechaLiberada === null)
      dispatch(putLiberarSolicitudDiscapacidad(
        itemTomado,
        'currentUser',
        true,
        setOpenAlert,
        item,
        setOpenModalAuditar
      ));
      setOpenAlert(false);
    };
    const handleCloseAlert = () => {
      setOpenAlert(false);
    };
  return (
    <>
    {openAlert && (
        <Dialog
          open={openAlert}
          onClose={handleCloseAlert}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Typography
                style={{ color: "#222" }}
              >
                Actualmente tiene una solicitud tomada, desea liberarla para tomar la solicitud N°{item.idSolicitud}?
              </Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleCloseAlert}
              variant="contained"
              color="primary"
            >
              Cancelar
            </Button>
            <Button
              onClick={handleLiberar}
              variant="contained"
              color="primary"
              autoFocus
            >
              Liberar
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {openModalAuditar &&
        <ModalAuditarSolicitudIntegracion
          disabled={disabled}
          open={openModalAuditar}
          closeModalHandler={() => {
            setOpenModalAuditar(false);
          }}
          solicitud={item}
        />
      }      
      {openModalHistorialCambios && (
        <ModalHistorialCambios
          open={openModalHistorialCambios}
          closeModalHandler={() => {
            setOpenModalHistorialCambios(false);
          }}
          openIntegracion
          solicitud={item}
          titulo={`Solicitud Integracion N° ${item.idSolicitud}`}
        />
      )}
      <TableRow className={classes.root} >        
        <TableCell align="center" sx={{padding: "10px"}}>
          <InfoHistorialIcon 
          onClick={() => setOpenModalHistorialCambios(true)} 
          />
        </TableCell>
        <TableCell align="center">
          <IconEstado
            useColorTable={true}
            texto={item?.estadoSolicitud?.letra}
            backgroundColor={item?.estadoSolicitud?.color}
            descripcion={item?.estadoSolicitud?.descripcion}
          />
        </TableCell>
        <TableCell align="left">
          {new Date(item?.fecha).toLocaleString("es", optionsfecha)}
        </TableCell>
        <TableCell align="left">{item?.idSolicitud}</TableCell>
        <TableCell align="left">{item?.tipoSolicitudIntegracion?.descripcion}</TableCell>
        <TableCell align="left">{item?.subTipoSolicitudIntegracion?.descripcion}</TableCell>
        <TableCell align="left">{item?.diagnostico?.descripcion}</TableCell>
        {/* <TableCell>
          {item.practicas.length > 0 && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCell> */}
        <TableCell align="left">{item?.efectorFacturacion?.nombreFantasia}</TableCell>
        <TableCell align="left">{item.afiliado?.apellido_y_nombre}</TableCell>
        <TableCell align="left">{item.afiliado?.carnet}</TableCell>
        <TableCell align="left">
          {item.solicitudesIntegracionTomadas[0]?.usuarioTomada?.userName}
        </TableCell>
        <TableCell>
          {(item?.idEstadoSolicitud ===
            ESTADO_SOLICITUD_INTEGRACION.EN_CARGA && tieneBandejaEnCarga) && (
            <Button
              style={{ fontSize: "0.8rem" }}
              variant="contained"
              color="primary"
              onClick={() => {
                postIrASolicitud(item);
              }}
            >
              Ir
            </Button>
          )}          
          {((item?.idEstadoSolicitud ===
            ESTADO_SOLICITUD_INTEGRACION.AUDITORIA_ADMINISTRATIVA && tieneBandejaPendiente) ||
            (item?.idEstadoSolicitud ===
            ESTADO_SOLICITUD_INTEGRACION.PENDIENTE_AUTORIZACION && tieneBandejaPendienteAutorizacion)) && (
            <Button
              style={{ fontSize: "0.8rem" }}
              disabled={
                item.solicitudesIntegracionTomadas?.length > 0 &&
                item.solicitudesIntegracionTomadas[0]?.idUsuarioTomada !== idUsuario
              }
              variant="contained"
              color="primary"
              onClick={() => {
                if(solicitudesTomadasUsuario.filter((x) => x.idUsuarioTomada === idUsuario && x.fechaLiberada === null && x.idSolicitud !== item.idSolicitud).length > 0){
                  setOpenAlert(true)
                }else{
                dispatch(postTomarSolicitudDiscapacidad(item, setOpenModalAuditar));
              }}}
            >
              Auditar
            </Button>
          )}
          {(item?.idEstadoSolicitud ===
            ESTADO_SOLICITUD_INTEGRACION.AUTORIZADA ||
            item?.idEstadoSolicitud ===
            ESTADO_SOLICITUD_INTEGRACION.RECHAZADA) && (
            <Button
              style={{ fontSize: "0.8rem" }}
              variant="contained"
              color="primary"
              onClick={() => {
                dispatch( setSolicitudDiscapacidad(item) );
                setOpenModalAuditar(true);
              }}
            >
              Ver
            </Button>
          )}
        </TableCell>
      </TableRow>
    </>
  );
};
